import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { toast } from 'react-toastify'
import i18n from '../i18n/i18n'
import { DecodedTokenTypes } from '../interfaces/decodedToken'
import { isLimitedModeRefusal } from './subscription/limitedModeError'
import { shouldWarnOnce } from './subscription/limitedModeWarning'

const apiUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_STAGING_API_URL
    : process.env.REACT_APP_PRODUCTION_API_URL

const instance = axios.create({
  baseURL: apiUrl,
})

const getUserType = (): DecodedTokenTypes['user_type'] | null => {
  const stored =
    localStorage.getItem('token') ?? sessionStorage.getItem('token')
  if (!stored) return null
  try {
    const access = JSON.parse(stored)?.access
    return access ? jwtDecode<DecodedTokenTypes>(access).user_type : null
  } catch {
    return null
  }
}

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      isLimitedModeRefusal(error) &&
      shouldWarnOnce(window.location.pathname)
    ) {
      // Nobody is redirected. An unactivated account stays on the page it is
      // on and the app turns read-only around it (see `useLimitedMode`) -
      // being thrown onto Plan & Billing mid-task was worse than the 403.
      // Only the administrator can clear the block, so only they are pointed
      // at the payment; everyone else is pointed at their administrator.
      const message =
        getUserType() === 'ADMINISTRATOR'
          ? 'accountAwaitingActivationAdmin'
          : 'accountAwaitingActivation'
      // The id collapses a burst of refusals from one screen into one toast,
      // the way `setupInterceptor` already does for the logout notice.
      toast.error(String(i18n.t(message)), { toastId: 'limitedMode' })
    }
    return Promise.reject(error)
  },
)

export default instance
